import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./headercomponent.css";
import menuIcon from "./assets/menu.svg";
import landingPageLogo from "./assets/PDVlogo.svg";

const HeaderComponent = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light px-2 sticky-top bg-white">
      <div className="container-fluid">
        <Link
          className="navbar-brand d-flex align-items-center navbar-title"
          to="/"
        >
          <img
            width="180"
            src={landingPageLogo}
            alt="Patient Data Vault logo"
            loading="lazy"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span>
            <img src={menuIcon} alt="" width={40} />
          </span>
        </button>
        <div
          className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
          id="navbarNav"
          style={{ marginRight: "30px" }}
        >
          <div className="ms-auto d-flex gap-4 flex-column flex-lg-row">
            <NavLink to="/about" className="custom-link">
              About Us
            </NavLink>
            <NavLink to="/feature" className="custom-link">
              Feature
            </NavLink>
            <NavLink to="/volunteer" className="custom-link">
              Volunteer
            </NavLink>
            <NavLink to="/contact-us" className="custom-link">
              Contact Us
            </NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default HeaderComponent;
